module.exports = __webpack_public_path__ + "img/config.ce2e3cb8.png";